var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.component,{tag:"component",attrs:{"idAntenna":_vm.idAntenna,"type":_vm.type,"serviceView":_vm.service},on:{"changeComponent":_vm.changeComponent,"service":_vm.serviceManager}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }